import { InitService } from "@/services";
import * as types from "@/store/types";
import { mapActions, mapGetters } from "vuex";
import VueQrcode from "vue-qrcode";

const ManualKyc = () =>
  import(
    /* webpackChunkName: "ManualKyc" */ "@/components/AccountPage/Kyc/ManualKyc"
  );

export default {
  name: "no-webcam",
  data() {
    return {
      isModalOpen: false,
      loading: false,
      userHasWebcam: true
    };
  },

  mounted() {
    navigator.mediaDevices.enumerateDevices().then(res => {
      const hasAudio = res.find(el => el.kind === "audioinput");
      const hasVideo = res.find(el => el.kind === "videoinput");
      if (hasAudio && hasVideo) this.userHasWebcam = true;
      else this.userHasWebcam = false;
    });
    // navigator.mediaDevices
    //   .getUserMedia()
    //   .then(() => {
    //     this.userHasWebcam = true;
    //     navigator.mediaDevices.getUserMedia({ video: false, audio: false });
    //   })
    //   .catch(() => (this.userHasWebcam = false));
  },
  components: {
    ManualKyc,
    VueQrcode
  },

  computed: {
    ...mapGetters({
      initData: types.init.getters.GET_INIT_DATA
    }),
    modal: {
      get() {
        return this.isModalOpen;
      },
      set(val) {
        this.isModalOpen = val;
      }
    }
  },
  methods: {
    ...mapActions({
      isAuthAction: types.auth.actions.ACTION_CHECK_IS_AUTH,
      setInit: types.init.actions.SET_INIT_DATA
    }),
    openModal() {
      this.isModalOpen = true;
      this.getInit();
    },
    closeModal() {
      this.isModalOpen = false;
    },
    openNormalVerifyModal() {
      this.$refs.manualKYC.openKYCNormalModal();
    },
    getInit() {
      this.loading = true;
      InitService.init().then(res => {
        this.loading = false;
        this.setInit(res.data.data);
      });
    }
  }
};
